// extracted by mini-css-extract-plugin
export default {"learnMoreBtn":"LearnMoreBtn_learnMoreBtn__EmgjR"};